import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { BsFillPersonFill } from "react-icons/bs";
import { HiOutlineViewGrid, HiViewGrid } from "react-icons/hi";
import { TfiEmail } from "react-icons/tfi";
import { GoHome } from "react-icons/go";
import { TbMessageQuestion } from "react-icons/tb";
import { CONTRY_CITY_CHECK_API, GET_BLOG_CHECK_API } from '../../config/config';
import axios from 'axios';

const MobileFooter = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Get the last part of the path as a slug
  const pathSegments = pathname.split("/").filter(Boolean);
  const slug = pathSegments[pathSegments.length - 1];
  const isEnquiry =
    pathname.startsWith('/enquiry-ktc');
  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [isCategorySelected, setIsCategorySelected] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [classify, setClassify] = useState("");
  const [isCategoryPath, setIsCategoryPath] = useState(false);
  const [loading, setLoading] = useState(false)
  const isHome = pathname === '/' || classify === 'Homepage';
  const isAbout = pathname === '/about';
  const isContact = pathname === '/contact-us';


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowFooter(false); // scrolling down - hide
      } else {
        setShowFooter(true); // scrolling up - show
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    const offcanvas = document.getElementById('offcanvasExample');

    const handleHidden = () => {
      if (!isCategorySelected) {
        setIsCanvasOpen(false);
      }
    };

    if (offcanvas) {
      offcanvas.addEventListener('hidden.bs.offcanvas', handleHidden);
    }

    return () => {
      if (offcanvas) {
        offcanvas.removeEventListener('hidden.bs.offcanvas', handleHidden);
      }
    };
  }, [isCategorySelected]);

  const RemoveMarketArea = () => {
    localStorage.removeItem("city_name");
    localStorage.removeItem("country_name");
  };

  useEffect(() => {

    if (!slug) return;

    const checkSlug = async () => {
      const excludedPaths = [
        "/track-your-delivery", "/clothing-franchise", "/contact-us", "/about",
        "/career", "/privacy-policy-2", "/terms-condition", "/return-policy",
        "/market-area", "/customer-review", "/faq", "/blog"
      ];
      const isExcluded = () =>
        ["/enquiry-ktc", "/blog", "/career"].some(p => pathname.startsWith(p)) ||
        excludedPaths.includes(pathname.replace(/\/+$/, ""));

      try {
        const { data } = await axios.post(CONTRY_CITY_CHECK_API, { slug });
        const classifyType = data?.classify;
        setClassify(classifyType);
        setIsCategoryPath(
          !["country", "city", "blog"].includes(classifyType) &&
          !isExcluded() &&
          (/^\/[^/]+\/?$/.test(pathname) || /^\/[^/]+\/[^/]+\/?$/.test(pathname))
        );
      } catch (err) {
        console.error("Slug classify fetch error:", err);
        setIsCategoryPath(
          !isExcluded() &&
          (/^\/[^/]+\/?$/.test(pathname) || /^\/[^/]+\/[^/]+\/?$/.test(pathname))
        );
      }
    };

    checkSlug();
  }, [slug, pathname]);

  useEffect(() => {
    if (!slug) return;

    const checkSlugClassification = async () => {
      setLoading(true);

      try {
        // Step 1: Call CONTRY_CITY_CHECK_API
        const countryResponse = await axios.post(CONTRY_CITY_CHECK_API, { slug });
        const countryClassify = countryResponse?.data?.classify;

        if (["country", "city"].includes(countryClassify)) {
          setClassify("Homepage");
          return setLoading(false);
        }
      } catch (error) {
        console.warn("CONTRY_CITY_CHECK_API failed or not matched:", error.response?.data?.message);
      }

      try {
        // Step 2: Call GET_BLOG_CHECK_API 
        const countryResponse = await axios.post(GET_BLOG_CHECK_API, { slug });

        const countryClassify = countryResponse?.data?.DATA?.classify;
        console.log("api", countryClassify);

        if (countryResponse?.data?.DATA?.classify === "BlogDetails") {
          setClassify("blog");
          setIsCategoryPath(false);
          return setLoading(false);;
        }
      } catch (error) {
        console.warn("CONTRY_CITY_CHECK_API failed or not matched:", error.response?.data?.message);
      }
    };

    checkSlugClassification();
  }, [slug]);

  useEffect(() => {
    if (["/", "/about", "/contact-us", "/enquiry-ktc"].includes(pathname)) {
      setIsCategoryPath(false);
    }
  }, [pathname]);

  return (
    <Container fluid className={`mobile-footer ${showFooter ? 'show' : 'hide'}`}>
      <Row className="py-2 pt-2 fw-medium">
        {/* Home */}
        <Col className="px-0">
          <NavLink to="/" className="mobi-footer-icon d-flex flex-column align-items-center" onClick={RemoveMarketArea}>
            <GoHome style={{ fontSize: '7vw', color: isHome ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isHome ? '#dc3545' : '#3E3E3E' }}>
              Home
            </span>
          </NavLink>
        </Col>

        {/* About Us */}
        <Col className="px-0">
          <NavLink to="/about" className="mobi-footer-icon d-flex flex-column align-items-center" onClick={RemoveMarketArea}>
            <BsFillPersonFill style={{ fontSize: '7vw', color: isAbout ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isAbout ? '#dc3545' : '#3E3E3E' }}>
              About Us
            </span>
          </NavLink>
        </Col>

        {/* Category */}
        <Col className="px-0">
          <div
            className="mobi-footer-icon d-flex flex-column align-items-center"
            onClick={() => setIsCanvasOpen(true)}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasExample"
          >
            {isCategoryPath || isCanvasOpen ? (
              <HiViewGrid style={{ fontSize: '7vw', color: '#dc3545' }} />
            ) : (
              <HiOutlineViewGrid style={{ fontSize: '7vw', color: '#3E3E3E' }} />
            )}
            <span
              className="mt-0 fw-bold text-center them-font"
              style={{ color: isCategoryPath || isCanvasOpen ? '#dc3545' : '#3E3E3E' }}
            >
              Category
            </span>
          </div>
        </Col>

        {/* Contact */}
        <Col className="px-0">
          <NavLink to="/contact-us" className="mobi-footer-icon d-flex flex-column align-items-center" onClick={RemoveMarketArea}>
            <TfiEmail style={{ fontSize: '7vw', color: isContact ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isContact ? '#dc3545' : '#3E3E3E' }}>
              Contact
            </span>
          </NavLink>
        </Col>

        {/* Enquiry */}
        <Col className="px-0">
          <NavLink to="/enquiry-ktc" className="mobi-footer-icon d-flex flex-column align-items-center" onClick={RemoveMarketArea}>
            <TbMessageQuestion style={{ fontSize: '7vw', color: isEnquiry ? '#dc3545' : '#3E3E3E' }} />
            <span className="mt-0 fw-bold text-center them-font" style={{ color: isEnquiry ? '#dc3545' : '#3E3E3E' }}>
              Enquiry
            </span>
          </NavLink>
        </Col>
      </Row>
    </Container>
  );
};

export default MobileFooter;
